import { yup } from '../../../shared/utils/yup';
import { IPortalEvent } from '../../event/types';

const yupEvent: Partial<Record<keyof IPortalEvent, yup.BaseSchema>> = {
  title: yup.string().required().nullable().max(200),
  description: yup.string().nullable().max(3000),
};

export const eventSchema = yup.object({}).shape(yupEvent);
